import styled from 'styled-components';

export const Frequency = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  grid-gap: 8px;
`;

export const LabelBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 40px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 24px;
  }
`;

export const Grow = styled.div`
  flex: 1;
`;
